// Constantes de Negocio
export const STORE_NAME = "VALLE DEL SOL";

export const DEFAULT_CATEGORIES = [
  "Viandas",
  "Productos",
  "Pastas",
  "Pastelería",
  "Pizzas",
  "Empanadas",
  "Combos",
];

export const EXPENSE_CATEGORIES = [
  "Materia Prima",
  "Insumos",
  "Servicios",
  "Alquiler",
  "Impuestos",
  "Sueldos",
  "Otros",
];

export const PANTRY_CATEGORIES = [
  "Verduleria",
  "Dietetica",
  "Descartables",
  "Limpieza",
  "Supermercado",
  "Imprenta",
  "Otros",
];

// URLs de Imágenes
export const LOGO_URL = "https://i.ibb.co/Y4Wn17j3/Icono.png";
export const VEGAN_URL = "https://i.ibb.co/6RFj56ds/Vegan.png";
export const SGLUTEN_URL = "https://i.ibb.co/1YsCPqL8/Sin-Gluten.png";

// Funciones puras de utilidad

// --- CORRECCIÓN IMPORTANTE AQUÍ ---
export const formatDate = (dateInput) => {
  if (!dateInput) return "-";

  let date;

  // 1. Si ya es un objeto Date de JS
  if (dateInput instanceof Date) {
    date = dateInput;
  }
  // 2. Si es un Timestamp de Firebase (tiene método toDate)
  else if (dateInput && typeof dateInput.toDate === "function") {
    date = dateInput.toDate();
  }
  // 3. Si es un objeto seconds (Timestamp serializado)
  else if (dateInput && dateInput.seconds) {
    date = new Date(dateInput.seconds * 1000);
  }
  // 4. Si es un String
  else if (typeof dateInput === "string") {
    // Si tiene T es ISO, sino le agregamos hora para evitar timezone issues
    date = new Date(
      dateInput.includes("T") ? dateInput : dateInput + "T00:00:00"
    );
  } else {
    return "-";
  }

  // Verificar si la fecha es válida
  if (isNaN(date.getTime())) return "-";

  return date.toLocaleDateString("es-AR", { day: "numeric", month: "short" });
};

export const getTodayString = () => new Date().toISOString().split("T")[0];

export const addDays = (dateString, days) => {
  const date = new Date(dateString);
  date.setDate(date.getDate() + days);
  return date.toISOString().split("T")[0];
};

export const calculateExpiry = (date, months) => {
  if (!date || !months) return "";
  return addDays(date, parseInt(months) * 30);
};

export const formatPrice = (price) =>
  new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price || 0);

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.onerror = (error) => reject(error);
  });
};
